<template>
  <custom-callout
    class="document-callout"
    :border-color-hex="item.status && item.status.color"
    :controlled="true"
    :has-toggle="hasCalloutToggle"
    :opened="isOpen"
    @click:open="toggle"
  >
    <div class="document-row">
      <div class="document-row__status">
        <custom-balloon
          :background-color="item.status && item.status.color"
          dot
          :text="item.status && item.status.name"
        />
      </div>
      <div class="document-row__data document-row__data--main">
        <div class="data-name">Documento:</div>
        <div class="document-row__value">{{ item.typeName | empty }}</div>
      </div>
      <div class="document-row__data">
        <div class="data-name">Fecha:</div>
        <div class="document-row__value">{{ item.date | date }}</div>
      </div>
      <div class="document-row__data">
        <div class="data-name">Archivo:</div>
        <div class="document-row__value">{{ item.fileName | empty }}</div>
      </div>
      <div class="document-row__actions">
        <dropdown name="Actions" title="Acciones" :items="actions" />
      </div>
    </div>

    <template #edition>
      <document-history :is-loading="isHistoryLoading" :items="history" />
    </template>
  </custom-callout>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import Dropdown from 'dropdown';
import DocumentHistory from './DocumentHistory.vue';

export default {
  name: 'DocumentsTabResultRow',
  components: {
    CustomBalloon,
    CustomCallout,
    DocumentHistory,
    Dropdown,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    history: {
      type: Array,
      default: () => [],
    },
    isHistoryLoading: {
      type: Boolean,
      default: () => false,
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    hasDetails() {
      return Boolean(this.item.id);
    },
    hasCalloutToggle() {
      return this.hasDetails || Boolean(this.item.reportId);
    },
    hasDownloadableDocument() {
      return Boolean(
        this.item.documentId || this.item.reportId || this.item.reportParameters
      );
    },
    actions() {
      return [
        {
          label: 'Historial',
          icon: 'fas fa-history text-green',
          visible: Boolean(this.item.id),
          click: this.showHistory,
        },
        {
          label: 'Descargar',
          icon: 'fas fa-file-download text-green',
          visible: this.hasDownloadableDocument,
          click: () => this.$emit('download', this.item),
        },
        {
          label: 'Anejar documento',
          icon: 'fas fa-file-upload text-green',
          visible: !this.hasDownloadableDocument && !this.isReadOnly,
          click: () => this.$emit('select', this.item),
        },
        {
          label: 'Reemplazar',
          icon: 'fas fa-file-plus text-green',
          visible: this.item.canReplace && !this.isReadOnly,
          click: () => this.$emit('replace', this.item),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-red',
          visible: this.item.canDelete && !this.isReadOnly,
          click: () => this.$emit('remove', this.item),
        },
      ].filter((action) => action.visible !== false);
    },
  },
  methods: {
    toggle() {
      if (!this.hasDetails) {
        this.$emit('close-history');
        return;
      }

      if (this.isOpen) {
        this.$emit('close-history');
      }
    },
    showHistory() {
      if (!this.hasDetails) return;

      this.$emit('history', this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.document-row {
  align-items: center;
  display: grid;
  gap: 18px;
  grid-template-columns:
    minmax(110px, 0.65fr) minmax(240px, 1.35fr) minmax(120px, 0.7fr)
    minmax(160px, 1fr) auto;
  min-height: 44px;
}

.document-row__value {
  color: #111;
  font-size: 13px;
  line-height: 1.25;
}

.document-row__actions {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

::v-deep .data-name {
  color: #727272;
  font-size: 12px;
}

@media (max-width: 991.98px) {
  .document-row {
    align-items: flex-start;
    grid-template-columns: 1fr auto;
  }

  .document-row__status,
  .document-row__data {
    grid-column: 1 / 2;
  }

  .document-row__actions {
    grid-column: 2 / 3;
    grid-row: 1 / 3;
  }
}
</style>
